import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { IonButton, IonButtons, IonCheckbox, IonContent, IonFooter, IonHeader, IonIcon, IonItem, IonLabel, IonNav, IonSpinner, IonToolbar, ModalController, Platform, ViewDidEnter, IonAvatar } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { alert, alertCircle, checkmarkCircle, checkmarkDoneOutline, close, documentLockOutline, informationCircleOutline } from 'ionicons/icons';
import { ApiService } from 'src/app/api.service';
import { Group, GroupField, GroupPrivacy, GroupPrivacyConsent, GroupPrivacyConsentUser } from 'src/app/app.types';
import { PrivacyPage } from 'src/app/privacy/privacy.page';
import { GroupPrivacyPage } from 'src/app/group-privacy/group-privacy.page';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../auth.service';
import { TermsPage } from '../terms/terms.page';
import { Subscription } from 'rxjs';
import { AuthFieldsPage } from '../auth-nav/auth-fields/auth-fields.page';
import { Capacitor } from '@capacitor/core';
import { InAppBrowser, DefaultWebViewOptions } from '@capacitor/inappbrowser';

export interface UserPrivacy {
  gid: number
  firebaseUid?: string
  //informativa: boolean
  termini: boolean
  //profilazione: boolean
  //partner: boolean
  //commerciali: boolean
}

export interface UserPrivacyResponse {
  response: boolean
  message: string
  result: UserPrivacy
}

export interface SearchFNOMCEOResponse {
  response: boolean
  message: string
  results: string[]
}

export interface UserGroupDataResponse {
  response: boolean
  message: string
  result?: UserGroupData
}

export interface UserTrainingDataResponse {
  response: boolean
  message: string
  result?: UserTrainingData
}

export interface UserGroupData {
  ugdid: number
  firebaseUid: string
  gid: number
  data: any
}

export interface UserTrainingData {
  utdid: number
  firebaseUid: string
  tid: number
  data: any
}

@Component({
  selector: 'app-auth-form',
  templateUrl: './auth-form.page.html',
  styleUrls: ['./auth-form.page.scss'],
  imports: [
    CommonModule,
    FormsModule,
    IonHeader,
    IonToolbar,
    IonContent,
    IonItem,
    IonButtons,
    IonButton,
    IonIcon,
    IonLabel,
    //IonInput,
    IonFooter,
    IonSpinner,
    IonCheckbox,
    IonAvatar
]
})
export class AuthFormPage implements OnInit, ViewDidEnter, OnDestroy {


  private auth = inject(AuthService)
  groupFields: GroupField[] = []
  group: Group
  firebaseUid: string
  fromMenu = false
  redeem: any
  ugdid: number

  public userPrivacy: UserPrivacy
  gprivacy?: GroupPrivacy
  gprivacyConsent?: GroupPrivacyConsent[] = []
  gprivacyConsentUser?: GroupPrivacyConsentUser[] = []

  mandatoryRead = false
  //mandatoryRead2 = false
  checkingData = false
  inviteDiscarded = false

  ready = false
  bbsub: Subscription

  constructor(
    public modalController: ModalController,
    private api: ApiService,
    private nav: IonNav,
    private platform: Platform
  ) {
    addIcons({ informationCircleOutline, documentLockOutline, alert, alertCircle, checkmarkCircle, close, checkmarkDoneOutline })
  }

  ngOnDestroy() {
    if (this.bbsub) this.bbsub.unsubscribe()


  }

  channelStyle() {
    return (Capacitor.getPlatform() === "android") ? "16px" : "0px 8px 0px 0px"
  }

  ionViewDidEnter() {
    this.bbsub = this.platform.backButton.subscribeWithPriority(9999, () => {
      console.log("Back button disabled")
    })
  }

  async ngOnInit() {


    this.userPrivacy = {
      gid: this.group.gid,
      termini: false
    }

    if(this.fromMenu) {
      this.mandatoryRead = true
    }

    if (!this.group.custom_privacy) {
      this.mandatoryRead = true
    } else {
      const gpres = await this.api.getGroupPrivacy(this.group.gid)
      this.gprivacy = gpres.gprivacy

      const gpcres = await this.api.getGroupPrivacyConsent(this.group.custom_privacy ? this.group.gid : 1)
      this.gprivacyConsent = gpcres.consents

      const gpcures = await this.api.getGroupPrivacyConsentUser(this.firebaseUid, this.group.gid)
      this.gprivacyConsentUser = gpcures.consents

      for (const gpc of this.gprivacyConsent) {
        const gpcu = this.gprivacyConsentUser.filter((gpcu) => gpcu.gpcid == gpc.gpcid)
        if (gpcu.length == 0) {
          this.gprivacyConsentUser.push({
            firebaseUid: this.firebaseUid,
            gpid: this.gprivacy.gpid,
            gpcid: gpc.gpcid,
            value: false,
            gid: this.group.gid,
            version: this.gprivacy.version
          })
        }
      }
    }

    // const ugdr = await this.api.getUserGroupData(this.firebaseUid, this.group.gid)
    // console.log("getUserGroupData", JSON.stringify(ugdr, null, 2))

    // if (ugdr.result) {
    //   this.ugdid = ugdr.result.ugdid
    //   this.groupFields = ugdr.result.data.groupFields
    // }



    const upr = await this.auth.getUserPrivacy(this.firebaseUid, this.group.gid)
    if (upr.result) {
      this.userPrivacy = upr.result
      if (this.group.gid != 1) {
        this.userPrivacy.termini = true
      }
    } else {
      this.userPrivacy = {
        gid: this.group.gid,
        termini: this.group.gid == 1 ? false : true,
        firebaseUid: this.firebaseUid
      }
    }

    this.ready = true


  }

  getUserPrivacyConsentValue(gpc: GroupPrivacyConsent) {
    const gpcus = this.gprivacyConsentUser.filter((gpcu) => gpcu.gpcid == gpc.gpcid)
    if (gpcus.length > 0) {
      return gpcus[0].value
    }
    return false
  }

  consentChanged(event: any, gpc: GroupPrivacyConsent) {

    const gpcus = this.gprivacyConsentUser.filter((gpcu) => gpcu.gpcid == gpc.gpcid)
    if (gpcus.length > 0) {
      gpcus[0].value = event.detail.checked
    }

    console.log("gprivacyConsentUser", this.gprivacyConsentUser)

  }

  public acceptAllValue = false
  acceptAll() {
    console.log("acceptAllValue", this.acceptAllValue)
    //this.userPrivacy.commerciali = this.acceptAllValue
    //this.userPrivacy.informativa = this.acceptAllValue
    this.userPrivacy.termini = this.acceptAllValue
    //this.userPrivacy.partner = this.acceptAllValue
    //this.userPrivacy.profilazione = this.acceptAllValue
    for (const gpcu of this.gprivacyConsentUser) {
      gpcu.value = true
    }

    this.informativaChanged()

  }

  // async showPrivacy() {
  //   const modal = await this.modalController.create({
  //     component: PrivacyPage,
  //     componentProps: {
  //       mandatoryRead: true,
  //       group: this.group
  //     }
  //   })
  //   modal.present()
  //   const { data } = await modal.onDidDismiss()

  //   if (data) {
  //     this.mandatoryRead = data.mandatoryRead
  //   }
  // }

  async showGroupPrivacy() {
    const modal = await this.modalController.create({
      component: GroupPrivacyPage,
      componentProps: {
        group: this.group,
        mandatoryRead: true
      }
    })
    modal.present()
    const { data } = await modal.onDidDismiss()
    if (data) {
      console.log("data from GroupPrivacyPage", data)
      this.mandatoryRead = data.mandatoryRead
    }

  }

  informativaChanged() {
    //console.log("informativaChanged:", this.userPrivacy.informativa)
    // if (!this.mandatoryRead && this.userPrivacy.informativa) {

    //   this.api.showToast("Devi prima leggere l'informativa", "alert")
    //   setTimeout(() => {
    //     this.userPrivacy.informativa = false
    //   }, 300);
    // }
  }

  isoToDDMMYYYY(isoString: string): string {
    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based in JavaScript
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }




  async invalidateRedeem() {

    this.inviteDiscarded = true
    await this.api.invalidateRedeem(this.redeem.code, this.group.gid, this.firebaseUid, 0)
    if (this.ugdid) {
      await this.api.deleteUserGroupData(this.ugdid)
    }

    this.groupFields = []

    const gg = await this.api.groupById(1)
    this.group = gg.group
    await this.auth.saveSelectedGroup(this.group)

  }

  async showTerms() {
    const modal = await this.modalController.create({
      component: TermsPage,
      componentProps: {
        isModal: true
      }
    })
    modal.present()
  }


  dataIsReady() {

    // if (!this.groupFields) {
    //   this.groupFields = []
    // }

    // let gfvalid = false
    // const requiredCount = this.groupFields.filter((gf) => gf.required).length
    // const requiredValid = this.groupFields.filter((gf) => gf.required && gf.valid).length

    // if (requiredValid == requiredCount) {
    //   gfvalid = true
    // }
    if (!this.userPrivacy) {
      return false
    }

    if (this.group.custom_privacy && !this.mandatoryRead) {
      return false
    }

    if (this.mandatoryConsents() && this.userPrivacy.termini) {
      return true
    } else {
      return false
    }

    // return this.userPrivacy.informativa && gfvalid
    //return this.userPrivacy ? (this.userPrivacy.informativa && this.userPrivacy.termini) : false
  }

  mandatoryConsents() {
    let mandatory = true
    for (const gpc of this.gprivacyConsent) {
      if (gpc.mandatory) {
        const gpcus = this.gprivacyConsentUser.filter((gpcu) => gpcu.gpcid == gpc.gpcid)
        if (gpcus.length > 0) {
          if (!gpcus[0].value) {
            mandatory = false
            break
          }
        }
      }
    }

    return mandatory
  }

  async updateConsents() {
    //this.api.updateUserPrivacy(this.userPrivacy)
    if(this.fromMenu && this.group.custom_privacy) {
      for (const gpcu of this.gprivacyConsentUser) {
        await this.api.setGroupPrivacyConsentUser(gpcu)
      }
    }
    this.modalController.dismiss() 
  }

  // Finalize
  async updatePrivacy() {

    // if (this.group.gid != 1 && !this.mandatoryRead2) {
    //   const alert = await this.alertController.create({
    //     header: "Attenzione",
    //     message: `Per continuare con l'iscrizione al canale ${this.group.name} devi leggere la specifica informativa relativa al canale.`,
    //     buttons: [
    //       {
    //         role: "cancel",
    //         text: "Annulla"
    //       },
    //       {
    //         role: "cancel",
    //         text: "Leggi l'informativa privacy " + this.group.name,
    //         handler: () => {
    //           this.showGroupPrivacy()
    //         }
    //       }
    //     ]
    //   })
    //   await alert.present()
    //   return
    // }

    // if (this.group.gid != 1 && !this.userPrivacy.partner) {
    //   const alert = await this.alertController.create({
    //     backdropDismiss: false,
    //     header: "Attenzione",
    //     message: `Per poter accedere al canale ${this.group.name} è necessario il tuo consenso per comunicazione dei propri dati ai soggetti partner di Tempo`,
    //     buttons: [
    //       {
    //         text: "Torna indietro",
    //         role: "cancel"
    //       },
    //       {
    //         text: `Non iscrivermi al canale ${this.group.name}`,
    //         role: "destructive"
    //       }
    //     ]
    //   })
    //   await alert.present()
    //   const { role } = await alert.onDidDismiss()
    //   if (role == "cancel") {
    //     return
    //   }
    //   else if (role == "destructive") {
    //     await this.invalidateRedeem()
    //     return
    //   }
    // }

    console.log("User submitted data...")
    this.checkingData = true

    this.checkingData = false

    

    if (this.groupFields.length > 0 && !this.group.consents_rule) {
      this.nav.push(AuthFieldsPage, {
        userPrivacy: this.userPrivacy,
        groupFields: this.groupFields,
        gprivacyConsentUser: this.gprivacyConsentUser,
        group: this.group,
        firebaseUid: this.firebaseUid
      })
    } else {
      await this.api.updateUserPrivacy(this.userPrivacy)

      if (this.group.custom_privacy) {
        for (const gpcu of this.gprivacyConsentUser) {
          await this.api.setGroupPrivacyConsentUser(gpcu)
        }
      }


      await this.api.setUserGroupData(this.firebaseUid, this.group.gid, [])
      this.modalController.dismiss()
    }

  }

}
